import { useSelector } from 'react-redux';
import {
  selectActiveBuilding,
  selectActiveBuildingId
} from '@/features/building/buildingSlice';
import { usePermissions } from '@/hooks/usePermissions';
import { useGetBannersQuery } from "@/api/banners";

const HIDDEN_WIDGET_ROLES = [290] // GMC_Altyn_Taraz

const useStatWidgetVisibility = () => {
  const { hasPermissionOrFallback, userRoles } = usePermissions();
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const activeBuilding = useSelector(selectActiveBuilding);
  const { data: banner } = useGetBannersQuery(activeBuildingId, {
    refetchOnMountOrArgChange: 60
  });

  const shouldShowQRCode = activeBuilding?.name?.startsWith('ЖК');

  const isHiddenWidgetRole = (userRoles || []).some((roleId) =>
    HIDDEN_WIDGET_ROLES.includes(roleId)
  )

  const canViewWidget = (permissionName, fallback = true) => {
    if (isHiddenWidgetRole) {
      return false
    }
    return hasPermissionOrFallback(permissionName, fallback)
  }

  const visibility = {
    monitoring:
      !!banner?.monitoring?.length &&
      canViewWidget('widget.monitoring', true),
    activeCameras: canViewWidget('widget.activeCameras', true),
    barrierTriggers: canViewWidget('widget.barrierTriggers', true),
    paid: canViewWidget('widget.paid', true),
    recognitions: canViewWidget('widget.recognitions', true),
    parking:
      activeBuilding?.parking_places > 0 &&
      canViewWidget('widget.parking', true),
    qrCode: shouldShowQRCode && canViewWidget('widget.qrCode', true)
  };

  return {
    visibility,
    banner,
    activeBuilding,
    activeBuildingId
  };
};

export default useStatWidgetVisibility;
